import axios from "axios";
import { getProperty } from "../utils/config-util";

const apiGatewayUrl = getProperty("API_GATEWAY_URL", "https://noa-gateway-amqp-dev.apps.np.sdppcf.com/api/lanes");


export async function lanesLogout(refreshTokenId, options) {
    const response = await axios({
        method: "POST",
        url: `${apiGatewayUrl}/identity/v2/logout`,
        data: { refreshTokenId },
        headers: {
			"Access-Control-Allow-Origin": "*",
		},
        ...options,
    });

    const data = response.data?.data;
    return data;
}
